import { SET_CLIENT_KEY } from 'actions';

export function setClientKey(key: string) {
  return { key, type: SET_CLIENT_KEY };
}
